export enum WayToChargeIdleFee {
    PER_DURATION = 'PER_DURATION',
    PER_KWH = 'PER_KWH',
    NONE = 'NONE',
}

export const IdleChargePeriodDefault = "PT1M"

// Mirrors WEB_FLOW in tupi-backend (src/models/stations.ts). Controls where the
// station QR code sends the driver: straight to the app, or to a web page first.
export const WEB_FLOW = {
    disabled: "disabled",
    redirectToStation: "enabled_redirect_to_station",
    redirectToGateway: "enabled_redirect_to_gateway",
} as const;